import styles from './styles.module.scss'

function VideoMessage({ url }) {
  return (
    <div className={styles.video_message}>
      <video src={url} controls />
    </div>
  )
}

export default VideoMessage
